var _title, _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnmuteButton = function SvgUnmuteButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "30. Sound level 0%")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "30.-Sound-level-0%",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 2.000000)",
    stroke: "white",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,33 L41.1547359,10.9416772 C43.2784166,9.17209479 45,9.96819655 45,12.728427 L45,83.0157762 C45,85.7721532 43.2793189,86.5728602 41.1547359,84.802526 L15,63 L2.99942248,63 C1.34288718,63 0,61.6526814 0,59.9999809 L0,36.0000191 C0,34.3431543 1.34435073,33 2.99942248,33 L15,33 Z",
    id: "Layer-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,85.1369725 C84.5904175,80.0307768 95.8510697,65.363628 95.8510697,48.0664131 C95.8510697,38.1922499 92.1815283,29.1751539 86.131767,22.3044466",
    id: "Layer-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,71.4633961 C73.3361812,68.7887497 80.9700853,59.3994824 80.9700853,48.2272212 C80.9700853,42.2002784 78.7485221,36.6922096 75.0796046,32.4772236",
    id: "Layer-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,58 C56.7092383,58 57.4012316,57.9261654 58.0687127,57.7857633 C62.5989154,56.8328525 66,52.8136092 66,48 C66,46.1642034 65.5053194,44.4439456 64.641985,42.9652536",
    id: "Layer-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.501341,0.498658982 L0.4881588,95.5118412",
    id: "Layer-5"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnmuteButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unmute-button.8ec0456d.svg";
export { ForwardRef as ReactComponent };